<!-- HOME PAGE -->
<div class="container">
  <!-- HEADER PAGE -->

  <!-- ROW TITLE -->
  <div fxLayout="row" fxLayoutAlign="center center">
    <div fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <!-- TITLE -->
      <div class="title-partner alicent">
        Partnership agreement application
      </div>
      <p class="psub">
        Our mission is also to support the research projects carried out by your organizations. As part of a research
        contract, we may grant you a free-of-charge use of our digital solutions.<br>Do not hesitate to briefly present
        to us the study protocol you wish to set up, using the dedicated form.<br>We are committed to contacting you within
        72 working hours.
      </p>


    </div>
  </div>

  <div class="form" [formGroup]="partnerForm" class="content_price_form" fxLayout="row wrap"
    fxLayoutAlign="center start">

    <!-- DIV YOUR STUDY -->
    <div div fxFlex="40" fxFlex.sm="90" fxFlex.xs="90" class="partner-form">

      <h2 class="info">Your Study</h2>
      <div>
        <mat-form-field class="example-full-width">
          <!-- <mat-label>Study needs</mat-label> -->
          <textarea formControlName="studyGoal" placeholder="Study Goal" matInput></textarea>
        </mat-form-field>
      </div>
      <mat-form-field class="example-full-width">
        <mat-label>Study category</mat-label>
        <mat-select formControlName="studyCategory">
          <mat-option *ngFor="let cat of studyCategoryArray" [value]="cat">
            {{cat}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div fxLayout fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayoutGap.xs="0">
        <mat-form-field fxFlex class="example-full-width">
          <input formControlName="nbSubjects" matInput placeholder="# of subjects">
        </mat-form-field>

        <mat-form-field fxFlex class="example-full-width">
          <input formControlName="nbSites" matInput placeholder="# of sites">
        </mat-form-field>
      </div>
      <div fxLayout fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayoutGap.xs="0">
        <mat-form-field fxFlex class="example-full-width">
          <input formControlName="nbUsers" matInput placeholder="# of app users">
        </mat-form-field>

        <mat-form-field fxFlex class="example-full-width">
          <input formControlName="nbCountries" matInput placeholder="# of countries">
        </mat-form-field>
      </div>
      <mat-form-field class="example-full-width">
        <input formControlName="enrollmentDuration" matInput placeholder="Enrollment duration">
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <input formControlName="fwpDuration" matInput placeholder="Subject follow-up duration">
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <input formControlName="upload" matInput placeholder="Volume of data to upload (if applicable)">
      </mat-form-field>
      <div>
        <mat-form-field class="example-full-width">
          <mat-label>Additional Comments <br><small>(please specify any information you think is useful)</small>
          </mat-label>
          <textarea formControlName="comment" matInput></textarea>
        </mat-form-field>
      </div>

    </div>

    <!-- DIV SPACER XL LG MD -->
    <div fxFlex.xl="10" fxFlex.lg="10" fxFlex.md="10"></div>

    <!-- DIV YOUR CONTACT -->
    <div div fxFlex="40" fxFlex.sm="90" fxFlex.xs="90" class="partner-form">
      <h2 class="info">Your Contact Details</h2>
      <div fxLayout fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayoutGap.xs="0">
        <mat-form-field fxFlex class="example-full-width">
          <input formControlName="firstName" matInput placeholder="First Name">
        </mat-form-field>

        <mat-form-field fxFlex class="example-full-width">
          <input formControlName="lastName" matInput placeholder="Last Name">
        </mat-form-field>
      </div>

      <mat-form-field class="example-full-width">
        <input formControlName="workEmail" type="email" email matInput placeholder="Work email">
      </mat-form-field>

      <div fxLayout fxLayout.xs="column" fxLayoutGap="20px" fxLayoutGap.xs="0" fxLayoutAlign="center center">
        <mat-form-field fxFlex class="example-full-width">
          <input formControlName="organization" matInput placeholder="Organization Name">
        </mat-form-field>

        <mat-form-field fxFlex class="example-full-width">
          <input formControlName="jobTitle" matInput placeholder="Job title">
        </mat-form-field>
      </div>

      <mat-form-field>
        <mat-label>Organization Size</mat-label>
        <mat-select formControlName="sizeCompany">
          <mat-option *ngFor="let size of sizeCompany" [value]="size">
            {{size}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="example-full-width">
        <input formControlName="phone" matInput placeholder="Mobile phone">
      </mat-form-field>

      <div fxLayout fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayoutGap.xs="0">
        <mat-form-field fxFlex class="example-full-width">
          <input type="text" placeholder="Industry" matInput formControlName="industry" [matAutocomplete]="auto1">
          <mat-autocomplete #auto1="matAutocomplete">
            <mat-option *ngFor="let option of industryFilter | async" [value]="option">
              {{option}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field fxFlex class="example-full-width">
          <input type="text" placeholder="Country" matInput formControlName="country" [matAutocomplete]="auto2">
          <mat-autocomplete #auto2="matAutocomplete">
            <mat-option *ngFor="let option of countryFilter | async" [value]="option">
              {{option}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <!-- DIV BUTTONS -->
    <div div fxFlex="90" class="partner-form">
      <div class="end-btns">
        <button class="back btn-wrapper" mat-raised-button color="alert" (click)="clickedBack()">Back</button>
        <button mat-raised-button class="send btn-wrapper" (click)="onSubmit()" color="primary"
          [disabled]="!partnerForm.valid" type="submit">Send</button>
      </div>
    </div>
  </div>

</div>
<!-- <div class="err buttons" *ngIf="!pricingFormValues">
    <div class="title alicent">Please start by filling the pricing form</div>
    <div class="subtitle alicent">
      You are:
    </div>
    <div>
      <mat-radio-group class="radio-gp" [(ngModel)]="orgType">
        <mat-radio-button class="radio-btn" value="1">Non-profit organization</mat-radio-button>
        <mat-radio-button class="radio-btn" value="2">Commercial law company</mat-radio-button>
      </mat-radio-group>
    </div>
  
      <div class="btncontainer buttons">
        <button mat-flat-button class="btn-start-hover color-3" [disabled]="orgType != null ? false : true" (click)="startPricing()">
          Start
        </button>
      </div>
  </div> -->

<app-footer></app-footer>
